import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";
import { joinUrl } from "@utils/index";

export default class deviceManageState extends baseState {
	// 设备列表
	@observable list = {};
	@action
	setList = data => {
		console.log(data, '设备列表');
		this.list = data;
	};

	getList = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.LIST,
			method: 'get',
			setState: "setList",
			data
		});
	};

	// 渠道列表
	@observable deptList = {};
	@action
	setDeptList(data) {
		this.deptList = data || {};
	}
	getDeptList = () => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.DEPT_LIST_ALL,
			setState: this.setDeptList,
			method: 'get',
		});
	};

	// 品牌列表无分页
	@observable brandList = [];
	@action
	setBrandList(data) {
		this.brandList = data || [];
	}
	getBranList = () => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.DEVICE_BRAND_LIST,
			setState: this.setBrandList,
			method: 'get',
		});
	};

	// 品牌列表分页
	@observable brandListPage = {};
	@action
	setBrandListPage(data) {
		this.brandListPage = data || {};
	}
	getBranListPage = (data) => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_BRAND_PAGE,
			setState: this.setBrandListPage,
			method: 'get',
			data
		});
	};

	// 设备品牌增删改
	insertBrand = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_BRAND_ADD, method: 'post', data }); // 创建
	updateBrand = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_BRAND_UPDATE, method: 'post', data }); // 更新
	deleteBrand = id => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_BRAND_DELETE.replace("{id}", id), method: 'post', data: { id } }); // 删除

	// 设备类型列表无分页
	@observable categoryList = [];
	@action
	setCategoryList(data) {
		this.categoryList = data || [];
	}
	getCategoryList = () => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.DEVICE_CATEGORY_LIST,
			setState: this.setCategoryList,
			method: 'get',
		});
	};

	// 设备类型列表分页
	@observable categoryListPage = {};
	@action
	setCategoryListPage(data) {
		this.categoryListPage = data || {};
	}
	getCategoryListPage = (data) => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_CATEGORY_PAGE,
			setState: this.setCategoryListPage,
			method: 'get',
			data
		});
	};

	// 设备类型增删改
	insertCategory = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_CATEGORY_ADD, method: 'post', data }); // 创建
	updateCategory = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_CATEGORY_UPDATE, method: 'post', data }); // 更新
	deleteCategory = id => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_CATEGORY_DELETE.replace("{id}", id), method: 'post', data: { id } }); // 删除

	// 型号列表无分页
	@observable modelList = [];
	@action
	setModelList(data) {
		this.modelList = data || [];
	}
	getModelList = () => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.DEVICE_MODEL_LIST,
			setState: this.setModelList,
			method: 'get',
		});
	};

	// 型号列表分页 
	@observable modelListPage = {};
	@action
	setModelListPage(data) {
		this.modelListPage = data || {};
	}
	getModelListPage = (data) => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_MODEL_PAGE,
			setState: this.setModelListPage,
			method: 'get',
			data
		});
	};

	// 设备型号增删改
	insertModel = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_MODEL_ADD, method: 'post', data }); // 创建
	updateModel = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_MODEL_UPDATE, method: 'post', data }); // 更新
	deleteModel = id => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_MODEL_DELETE.replace("{id}", id), method: 'post', data: { id } }); // 删除

	// 设备型号图片上传
	uploadImg = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_MODEL_UPLOAD_IMG, method: 'post', data });

	// 健康数据
	@observable healthyData = {};
	@action
	setHealthyPage(data) {
		this.healthyData = data || {};
	}
	getHealthyPage = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.HEALTHY_DATA,
			setState: this.setHealthyPage,
			method: 'get',
			data
		});
	};

	// 亲情列表分页
	@observable familyListPage = {};
	@action
	setFamilyListPage(data) {
		// console.log(data, '亲情列表');
		let obj = {};
		obj.records = data.sosNumbers || [];
		obj.total = data.sosNumbers ? data.sosNumbers.length : 0;
		this.familyListPage = obj;
	}
	getFamilyListPage = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.FAMILY_LIST,
			setState: this.setFamilyListPage,
			method: 'get',
			data
		});
	};

	// 设置亲情号
	insertFamily = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.FAMILY_SET, method: 'post', data }); // 创建亲情号

	// 轨迹列表
	@observable trackList = {};
	@action
	setTrackList = data => this.trackList = data;

	getTrackList = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.TRACK_LIST,
			method: 'get',
			setState: "setTrackList",
			data
		});
	};

	setTrackFence = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.TRACK_SET_FENCE,
			method: 'post',
			data
		});
	};

	// 设备导入模板下载
	deviceTemplate = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.IMPORT_TEMPLATE, method: 'post', data });

	// 用户列表无分页LIST_ALL
	@observable userList = {};
	@action
	setUserList = data => this.userList = data;

	getUserList = data => {
		return this.fetch({
			url: apiUrl.USER_MANAGE.LIST_ALL,
			method: 'get',
			setState: "setUserList",
			data
		});
	};

	// 编辑设备
	updateDevice = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.DEVICE_UPDATE, method: 'post', data }); // 更新

	// 解绑设备
	unBindDevice = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.DEVICE_UNBIND, method: 'post', data });

	// 获取设备详情
	getDeviceInfo = id => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.DEVICE_INFO.replace("{id}", id), method: 'get', data: {} });

  // 修改设备鼠标DPI
  updateDeviceMouseDpi = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.DEVICE_SET_MOUSE_DPI, method: 'post', data });

	// 功能列表分页
	@observable funcListPage = {};
	@action
	setFuncListPage(data) {
		this.funcListPage = data || {};
	}
	getFuncListPage = (data) => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_FUNC_LIST,
			setState: this.setFuncListPage,
			method: 'get',
			data
		});
	};

	// 设备品牌增删改
	insertFunc = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_FUNC_ADD, method: 'post', data }); // 创建
	updateFunc = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_FUNC_UPDATE, method: 'post', data }); // 更新
	deleteFunc = id => this.fetch({ url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_FUNC_DELETE.replace("{id}", id), method: 'post', data: { id } }); // 删除

	// 功能列表不分页 DEVICE_FUNC_LIST_ALL
	@observable funcListPageAll = {};
	@action
	setFuncListPageAll(data) {
		this.funcListPageAll = data || {};
	}
	getFuncListPageAll = () => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_BASIC_INFO.DEVICE_FUNC_LIST_ALL,
			setState: this.setFuncListPageAll,
			method: 'get',
		});
	};

	// 蓝牙设备列表
	@observable bluetoothList = {};
	@action
	setBluetoothList = data => this.bluetoothList = data;

	getBluetoothList = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.BLUETOOTH.LIST,
			method: 'get',
			setState: "setBluetoothList",
			data
		});
	};

	// 创建蓝牙
	insertBluetooth = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.BLUETOOTH.CREATE, method: 'post', data }); // 创建

	// 激活蓝牙
	activeBluetooth = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.BLUETOOTH.ACTIVE, method: 'post', data }); // 创建

	// 统计蓝牙
	@observable bluetoothTotal = {};
	@action
	setBluetoothTotal = data => this.bluetoothTotal = data;

	getBluetoothTotal = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.BLUETOOTH.AMOUNT,
			method: 'get',
			setState: "setBluetoothTotal",
			data
		});
	};

	// 省市区
	@observable cityAddress = {};
	@action
	setCityAddress = data => this.cityAddress = data;

	getCityAddress = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.BLUETOOTH.ADDRESS,
			method: 'get',
			setState: "setCityAddress",
			data
		});
	};

	// 蓝牙虚拟设备
	@observable virtualModel = {};
	@action
	setVirtualModel = data => this.virtualModel = data;

	getVirtualModel = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.BLUETOOTH.VIRTUAL_MODEL,
			method: 'get',
			setState: "setVirtualModel",
			data
		});
	};

	// 设备恢复出厂设置
	resetDevice = data => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.RESET,
			data,
		});
	};

	// 获取使用者下拉列表
	getUserDownList = deviceId => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.USER_DOWN_LIST + deviceId,
			method: 'get',
			// data: { deviceId }
		});
	};

	// 获取所有平台列表
	getPlayListAll = () => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.PLAT_LIST_ALL,
			method: 'get',
		});
	};


  // 鼠标授权分页
	@observable mouseAuthList = {};
	@action
	setMouseAuthList(data) {
		this.mouseAuthList = data || {};
	}
	getMouseAuthList = (data) => {
		return this.fetch({
			url: apiUrl.DEVICE_MANAGE.MOUSEAUTH.LIST,
			setState: this.setMouseAuthList,
			method: 'get',
			data
		});
	};

	// 鼠标授权增删改
	insertMouseAuth = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.MOUSEAUTH.ADD, method: 'post', data }); // 创建
	updateMouseAuth = data => this.fetch({ url: apiUrl.DEVICE_MANAGE.MOUSEAUTH.UPDATE, method: 'post', data }); // 更新
	deleteMouseAuth = id => this.fetch({ url: apiUrl.DEVICE_MANAGE.MOUSEAUTH.DELETE.replace("{id}", id), method: 'delete', data: { id } }); // 删除


}
